import React from "react";
import { Check, CheckCheck, X } from "lucide-react";
import { useNotifications } from "./NotificationContext";
import "./NotificationSystem.css";
import { Link } from "react-router-dom";

export const AllNotificationsPage = () => {
  const {
    notifications,
    markAsRead,
    showAllPage,
    setShowAllPage,
    markAsAllRead,
    markAllAsRead,
  } = useNotifications();

  // if (!showAllPage) return null;

  return (
    <div className="main-content">
      <div className="container">
        <div className="page-header">
          <Link to="/" className="back-link" style={{ marginTop: "1rem" }}>
            <svg
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
            >
              <path d="m15 18-6-6 6-6" />
            </svg>
            Back to Dashboard
          </Link>
          <h2>Notifications</h2>
          <button className="mark-all-btn" onClick={markAllAsRead}>
            <CheckCheck size={16} /> Mark all read
          </button>
        </div>
        <div className="page-body">
          {notifications.length === 0 && (
            <p className="empty-text">No notifications available.</p>
          )}
          {notifications.map((notif) => (
            <div
              key={notif.id}
              className={`page-notif-item ${notif.is_read ? "" : "unread"}`}
            >
              <p className="notif-message">{notif.message}</p>
              {!notif.is_read && (
                <button
                  className="read-btn"
                  onClick={() => markAsRead(notif.id)}
                >
                  <CheckCheck size={18} />
                </button>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
